import React, { useState } from 'react'
import { TbRefresh } from 'react-icons/tb'
import OutsideAlerter from '../../hooks/ClickOutside'
import {
    StyledRefreshFunctions,
    StyledMoreContainer,
    StyledDropDownMenu,
    StyledMenuItem,
    StyledDivider,
} from './styles'
import { useTheme } from 'styled-components'

export default function RefreshFunctions(props: {
    refreshFunctions: (isAllSheets: boolean) => void
    refreshErrors: () => void
}) {
    const theme = useTheme()
    const { refreshFunctions, refreshErrors } = props
    const [isOpened, SetIsOpened] = useState(false)

    return (
        <StyledRefreshFunctions
            style={
                Office.context.platform === Office.PlatformType.Mac
                    ? { right: '40px' }
                    : { right: '16px' }
            }
        >
            <StyledMoreContainer>
                <OutsideAlerter
                    onpress={() => {
                        SetIsOpened(false)
                    }}
                >
                    <TbRefresh
                        color={theme.colours.font.primary}
                        onClick={() => SetIsOpened(!isOpened)}
                    />
                    {isOpened ? (
                        <StyledDropDownMenu>
                            <StyledMenuItem
                                onClick={() => refreshFunctions(false)}
                            >
                                Refresh Current Tab
                            </StyledMenuItem>
                            <StyledDivider />
                            <StyledMenuItem
                                onClick={() => refreshFunctions(true)}
                            >
                                Refresh All Tabs
                            </StyledMenuItem>
                            <StyledDivider />
                            <StyledMenuItem onClick={() => refreshErrors()}>
                                Refresh Errors
                            </StyledMenuItem>
                        </StyledDropDownMenu>
                    ) : null}
                </OutsideAlerter>
            </StyledMoreContainer>
        </StyledRefreshFunctions>
    )
}
